<template>
  <v-container class="justify-center mt-16">
    <v-row justify="center">
      <v-col cols="12" sm="12" md="6" lg="4">
        <v-card class="elevation-12">
          <v-toolbar color="primary" dark flat> Unauthorized </v-toolbar>
          <v-row justify="center">
            <v-img
              alt="Vuetify Logo"
              class="justify-center shrink mt-8 mb-2"
              contain
              src="/img/login.png"
              transition="scale-transition"
              width="256"
            />
          </v-row>
          <v-card-text> </v-card-text>
          <v-card-actions>
            <v-spacer />
            <!-- <v-btn color="blue" dark @click="$router.push('/')"
              ><v-icon>mdi-home</v-icon>หน้าแรก</v-btn
            > -->
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data: () => ({}),
};
</script> 
